<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
    <div class="d-flex justify-content-between" style="margin-bottom: 10px">
      <div>
        <p style="font-size: 12px">
          <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table row
          for more option.
        </p>
      </div>
      <b-button-group v-if="editableOps">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="refreshTableAndCombo"
          >Refresh</b-button
        >
      </b-button-group>
    </div>
    <DxDataGrid
      id="cement-stage-grid"
      ref="cementStageGrid"
      :data-source="listItem"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      column-resize-mode="nextColumn"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :cell-hint-enabled="true"
      :word-wrap-enabled="true"
      :column-auto-width="false"
      :column-width="100"
      :height="300"
    >
      <DxPaging :enabled="false"/>
      <DxSelection mode="single"/>
      <DxScrolling column-rendering-mode="virtual"/>
      <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          :use-icons="true"
          mode="row"/>
      <DxColumn v-for="column in tableFields" :key="column.key" :data-field="column.key" :caption="column.label" :data-type="column.type" />
    </DxDataGrid>
    <hr />
    <h5 align="center">Pumping Schedule</h5>
    <hr />

    <PumpSchedule
      :stage-no="selectedStageNo"
      :well-id="wellId"
      :editable-ops="editableOps"
    />

    <!-- MODALS -->
    <b-modal
      id="modal-form-cement-stage"
      size="lg"
      :title="'FORM ' + selectedAction + ' CEMENT STAGE'"
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <b-form validated @submit="onSubmit" @reset="onReset">
          <hr />
          <h6>CEMENTING STAGES</h6>
          <hr />
          <b-form-group
            id="input-group-stageNo"
            label="Stage No:"
            label-for="input-stageNo"
            description="String "
          >
            <b-form-input
              id="input-stageNo"
              v-model="form.stageNo"
              type="search"
              list="list-stage-no"
              placeholder="Enter Stage No"
            ></b-form-input>
            <datalist id="list-stage-no">
              <option v-for="option in stageNoList" :key="option">{{
                option
              }}</option>
            </datalist>
          </b-form-group>
          <b-form-group
            id="input-group-type"
            label="Type:"
            label-for="input-type"
            description="String "
          >
            <b-form-input
              id="input-type"
              v-model="form.type"
              type="search"
              placeholder="Enter Type"
              list="stage-type-list"
            ></b-form-input>
            <datalist id="stage-type-list">
              <option v-for="option in stageTypeList" :key="option">{{
                option
              }}</option>
            </datalist>
          </b-form-group>

          <b-form-group
            id="input-group-mdTop"
            label="MD Top:"
            label-for="input-mdTop"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-mdTop"
              v-model="form.mdTop"
              type="number"
              step="0.001"
              placeholder="Enter MD Top"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tvdTop"
            label="TVD Top:"
            label-for="input-tvdTop"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-tvdTop"
              v-model="form.tvdTop"
              type="number"
              step="0.001"
              placeholder="Enter TVD Top"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-mdBase"
            label="MD Base:"
            label-for="input-mdBase"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-mdBase"
              v-model="form.mdBase"
              type="number"
              step="0.001"
              placeholder="Enter MD Base"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tvdBase"
            label="TVD Base:"
            label-for="input-tvdBase"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-tvdBase"
              v-model="form.tvdBase"
              type="number"
              step="0.001"
              placeholder="Enter TVD Base"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h6>STAGES DETAILS</h6>
          <hr />
          <b-form-group
            id="input-group-mdToolTop"
            label="MD Tool Top:"
            label-for="input-mdToolTop"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-mdToolTop"
              v-model="form.mdToolTop"
              type="number"
              step="0.001"
              placeholder="Enter MD Tool Top"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tvdCementTool"
            label="TVD Cement Tool:"
            label-for="input-tvdCementTool"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-tvdCementTool"
              v-model="form.tvdCementTool"
              type="number"
              step="0.001"
              placeholder="Enter TVD Cement Tool"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-mdPlugCirc"
            label="MD Plug Circ:"
            label-for="input-mdPlugCirc"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-mdPlugCirc"
              v-model="form.mdPlugCirc"
              type="number"
              step="0.001"
              placeholder="Enter MD Plug Circ"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tvdPlugCirc"
            label="TVD Plug Circ:"
            label-for="input-tvdPlugCirc"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-tvdPlugCirc"
              v-model="form.tvdPlugCirc"
              type="number"
              step="0.001"
              placeholder="Enter TVD Plug Circ"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-toolDesc"
            label="Tool Desc:"
            label-for="input-toolDesc"
            description="String "
          >
            <b-form-input
              id="input-toolDesc"
              v-model="form.toolDesc"
              type="text"
              placeholder="Enter Tool Desc"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-mdStageTool"
            label="MD Stage Tool:"
            label-for="input-mdStageTool"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-mdStageTool"
              v-model="form.mdStageTool"
              type="number"
              step="0.001"
              placeholder="Enter MD Stage Tool"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tvdStageTool"
            label="TVD Stage Tool:"
            label-for="input-tvdStageTool"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-tvdStageTool"
              v-model="form.tvdStageTool"
              type="number"
              step="0.001"
              placeholder="Enter TVD Stage Tool"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-initialCasingPress"
            label="Initial Casing Press:"
            label-for="input-initialCasingPress"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-initialCasingPress"
              v-model="form.initialCasingPress"
              type="number"
              step="0.001"
              placeholder="Enter Initial Casing Press"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalCasingPress"
            label="Final Casing Press:"
            label-for="input-finalCasingPress"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-finalCasingPress"
              v-model="form.finalCasingPress"
              type="number"
              step="0.001"
              placeholder="Enter Final Casing Press"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-initTbgPress"
            label="Init TBG Press:"
            label-for="input-initTbgPress"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-initTbgPress"
              v-model="form.initTbgPress"
              type="number"
              step="0.001"
              placeholder="Enter Init TBG Press"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalTbgPress"
            label="Final TBG Press:"
            label-for="input-finalTbgPress"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-finalTbgPress"
              v-model="form.finalTbgPress"
              type="number"
              step="0.001"
              placeholder="Enter Final TBG Press"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-ctUsed"
            label="CT Used:"
            label-for="input-ctUsed"
            description=" "
          >
            <b-form-checkbox
              id="input-ctUsed"
              v-model="form.ctUsed"
              type="number"
              placeholder="Enter CT Used"
              value="1"
              unchecked-value="0"
              size="md"
              @change="ctUsedChanged"
              >Used</b-form-checkbox
            >
          </b-form-group>
          <b-form-group
            id="input-group-mdCtu"
            label="MD CTU:"
            label-for="input-mdCtu"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-mdCtu"
              v-model="form.mdCtu"
              type="number"
              step="0.001"
              placeholder="Enter MD CTU"
              :disabled="ctUsedEnabled"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tvdCtu"
            label="TVD CTU:"
            label-for="input-tvdCtu"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-tvdCtu"
              v-model="form.tvdCtu"
              type="number"
              step="0.001"
              placeholder="Enter TVD CTU"
              :disabled="ctUsedEnabled"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-initialCtuPress"
            label="Initial CTU Press:"
            label-for="input-initialCtuPress"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-initialCtuPress"
              v-model="form.initialCtuPress"
              type="number"
              step="0.001"
              placeholder="Enter Initial CTU Press"
              :disabled="ctUsedEnabled"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalCtuPress"
            label="Final CTU Press:"
            label-for="input-finalCtuPress"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-finalCtuPress"
              v-model="form.finalCtuPress"
              type="number"
              step="0.001"
              placeholder="Enter Final CTU Press"
              :disabled="ctUsedEnabled"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-plugBumped"
            label="Plug Bumped:"
            label-for="input-plugBumped"
            description="Date "
          >
            <b-form-input
              id="input-plugBumped"
              v-model="form.plugBumped"
              type="datetime-local"
              placeholder="Enter Plug Bumped"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-floatHeld"
            label="Float Held:"
            label-for="input-floatHeld"
            description="Date "
          >
            <b-form-input
              id="input-floatHeld"
              v-model="form.floatHeld"
              type="datetime-local"
              placeholder="Enter Float Held"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-circulatePrior"
            label="Circulate Prior:"
            label-for="input-circulatePrior"
            description="Double (hr)"
          >
            <b-form-input
              id="input-circulatePrior"
              v-model="form.circulatePrior"
              type="number"
              step="0.001"
              placeholder="Enter Circulate Prior"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-circulateFlowRate"
            label="Circulate Flow Rate:"
            label-for="input-circulateFlowRate"
            description="Double (gpm)"
          >
            <b-form-input
              id="input-circulateFlowRate"
              v-model="form.circulateFlowRate"
              type="number"
              step="0.001"
              placeholder="Enter Circulate Flow Rate"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-circulatePress"
            label="Circulate Press:"
            label-for="input-circulatePress"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-circulatePress"
              v-model="form.circulatePress"
              type="number"
              step="0.001"
              placeholder="Enter Circulate Press"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-toolContractor"
            label="Tool Contractor:"
            label-for="input-toolContractor"
            description="String "
          >
            <b-form-input
              id="input-toolContractor"
              v-model="form.toolContractor"
              type="text"
              placeholder="Enter Tool Contractor"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-toolDescription"
            label="Tool Description:"
            label-for="input-toolDescription"
            description="String "
          >
            <b-form-input
              id="input-toolDescription"
              v-model="form.toolDescription"
              type="text"
              placeholder="Enter Tool Description"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-returns"
            label="Returns:"
            label-for="input-returns"
            description="String "
          >
            <b-form-input
              id="input-returns"
              v-model="form.returns"
              type="text"
              placeholder="Enter Returns"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-volReturns"
            label="Vol Returns:"
            label-for="input-volReturns"
            :description="'Double (' + $t('unit.bbl') + ')'"
          >
            <b-form-input
              id="input-volReturns"
              v-model="form.volReturns"
              type="number"
              step="0.001"
              placeholder="Enter Vol Returns"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-volumeLost"
            label="Volume Lost:"
            label-for="input-volumeLost"
            :description="'Double (' + $t('unit.bbl') + ')'"
          >
            <b-form-input
              id="input-volumeLost"
              v-model="form.volumeLost"
              type="number"
              step="0.001"
              placeholder="Enter Volume Lost"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-wocTime"
            label="WOC Time:"
            label-for="input-wocTime"
            description="Double (hr)"
          >
            <b-form-input
              id="input-wocTime"
              v-model="form.wocTime"
              type="number"
              step="0.001"
              placeholder="Enter WOC Time"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pressHeld"
            label="Press Held:"
            label-for="input-pressHeld"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-pressHeld"
              v-model="form.pressHeld"
              type="number"
              step="0.001"
              placeholder="Enter Press Held"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pressureRemaining"
            label="Pressure Remaining:"
            label-for="input-pressureRemaining"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-pressureRemaining"
              v-model="form.pressureRemaining"
              type="number"
              step="0.001"
              placeholder="Enter Pressure Remaining"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pressureHeldDuration"
            label="Pressure Held Duration:"
            label-for="input-pressureHeldDuration"
            description="Double (min)"
          >
            <b-form-input
              id="input-pressureHeldDuration"
              v-model="form.pressureHeldDuration"
              type="number"
              step="0.001"
              placeholder="Enter Pressure Held Duration"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-bumpPress"
            label="Bump Press:"
            label-for="input-bumpPress"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-bumpPress"
              v-model="form.bumpPress"
              type="number"
              step="0.001"
              placeholder="Enter Bump Press"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pressPriorBump"
            label="Press Prior Bump:"
            label-for="input-pressPriorBump"
            :description="'Double (' + $t('unit.psi') + ')'"
          >
            <b-form-input
              id="input-pressPriorBump"
              v-model="form.pressPriorBump"
              type="number"
              step="0.001"
              placeholder="Enter Press Prior Bump"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-hesitation"
            label="Hesitation:"
            label-for="input-hesitation"
            description=" "
          >
            <b-form-checkbox
              id="input-hesitation"
              v-model="form.hesitation"
              type="number"
              placeholder="Enter Hesitation"
              value="1"
              unchecked-value="0"
              @change="hesitationChanged"
              >Hesitated</b-form-checkbox
            >
          </b-form-group>
          <b-form-group
            id="input-group-hesitationReason"
            label="Hesitation Reason:"
            label-for="input-hesitationReason"
            description="String "
          >
            <b-form-input
              id="input-hesitationReason"
              v-model="form.hesitationReason"
              type="text"
              placeholder="Enter Hesitation Reason"
              :disabled="hesitationEnable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <b-button type="submit" variant="primary" style="margin-right: 5px"
            >Save</b-button
          >
          <b-button type="reset" variant="danger">Reset</b-button>
          <br />
        </b-form>
      </div>
    </b-modal>

    <b-modal
      id="modal-remove-cement-stage"
      title="Remove Cement Stage"
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <p
          >This activity will remove selected cement stage data from the table
          !!!</p
        >
        <p>Are you sure?</p>
        <hr />
        <b-btn style="margin-right: 0.5em" @click="closeModalRemove"
          >No</b-btn
        >
        <b-btn variant="danger" @click="askServerToRemoveData">Yes</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { formMethods } from '@state/helpers'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import PumpSchedule from '@components/form/drilling-activity/cement-pump-sch'

export default {
  components: { PumpSchedule, 
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
  },
  props: {
    submitId: {
      type: Number,
      default: undefined,
    },
    editableOps: {
      type: Boolean,
      default: false,
    },
    wellId: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      selectedRow: [],
      selectedStageNo: undefined,
      listItem: [],
      perPage: 10,
      tableBusy: false,
      currentPage: 1,
      ctUsedEnabled: true,
      hesitationEnable: false,
      stageTypeList: [],
      tableFields: [
        { key: 'stageNo', label: 'Stage No', type: 'string' },
        { key: 'type', label: 'Type', type: 'string' },
        { key: 'mdTop', label: 'MD Top', type: 'number' },
        { key: 'tvdTop', label: 'TVD Top', type: 'number' },
        { key: 'mdBase', label: 'MD Base', type: 'number' },
        { key: 'tvdBase', label: 'TVD Base', type: 'number' },
        { key: 'mdToolTop', label: 'MD Tool Top', type: 'number' },
        { key: 'tvdCementTool', label: 'TVD Cement Tool', type: 'number' },
        { key: 'mdPlugCirc', label: 'MD Plug Circ', type: 'number' },
        { key: 'tvdPlugCirc', label: 'TVD Plug Circ', type: 'number' },
        { key: 'toolDesc', label: 'Tool Description', type: 'string' },
        { key: 'mdStageTool', label: 'MD Stage Tool', type: 'number' },
        { key: 'tvdStageTool', label: 'TVD Stage Tool', type: 'number' },
        { key: 'initialCasingPress', label: 'Initial Casing Pressure', type: 'number' },
        { key: 'finalCasingPress', label: 'Final Casing Pressure', type: 'number' },
        { key: 'initTbgPress', label: 'Initial TBG Pressure', type: 'number' },
        { key: 'finalTbgPress', label: 'Final TBG Pressure', type: 'number' },
        { key: 'ctUsed', label: 'CT Used', type: 'number' },
        { key: 'mdCtu', label: 'MD CTU', type: 'number' },
        { key: 'tvdCtu', label: 'TVD CTU', type: 'number' },
        { key: 'initialCtuPress', label: 'Initial CTU Pressure', type: 'number' },
        { key: 'finalCtuPress', label: 'Final CTU Pressure', type: 'number' },
        { key: 'plugBumped', label: 'Plug Bumped', type: 'date' },
        { key: 'floatHeld', label: 'Float Held', type: 'number' },
        { key: 'circulatePrior', label: 'Circulate Prior', type: 'number' },
        { key: 'circulateFlowRate', label: 'Circulate Flow Rate', type: 'number' },
        { key: 'circulatePress', label: 'Circulate Pressure', type: 'number' },
        { key: 'toolContractor', label: 'Tool Contractor', type: 'string' },
        { key: 'toolDescription', label: 'Tool Description', type: 'string' },
        { key: 'returns', label: 'Returns', type: 'string' },
        { key: 'volReturns', label: 'Volume Returns', type: 'number' },
        { key: 'volumeLost', label: 'Volume Lost', type: 'number' },
        { key: 'wocTime', label: 'WOC Time', type: 'number' },
        { key: 'pressHeld', label: 'Pressure Held', type: 'number' },
        { key: 'pressureRemaining', label: 'Pressure Remaining', type: 'number' },
        { key: 'pressureHeldDuration', label: 'Pressure Held Duration', type: 'number' },
        { key: 'bumpPress', label: 'Bump Pressure', type: 'number' },
        { key: 'pressPriorBump', label: 'Prior Bump Pressure', type: 'number' },
        { key: 'hesitation', label: 'Hesitation', type: 'number' },
        { key: 'hesitationReason', label: 'Hesitation Reason', type: 'string' },
      ],
      selectedAction: '',
      form: [],
      show: false,
      stageNoList: [],
      cementStageIsLoading: false,
    }
  },

  computed: {
    totalRows: function () {
      return this.listItem.length
    },
  },

  watch: {
    submitId: function (val, oldVal) {
      this.refreshTableAndCombo()
    },
    selectedRow: function (val) {},
  },

  created: function () {
    this.refreshTableAndCombo()
  },

  methods: {
    ...formMethods,
    refreshTableAndCombo() {
      this.tableBusy = true
      this.listItem = []
      this.getActivityCementStage({
        params: { submitId: this.submitId },
      }).then((resp) => {
        this.listItem = resp.data.data
        this.tableBusy = false
      })
      this.loadAllCombo()
    },
    loadAllCombo() {
      this.loadComboStageNo()
      this.loadComboStageType()
    },
    loadComboStageType() {
      this.stageTypeList = []
      this.getComboCementStageType({}).then((resp) => {
        var _arrData = resp.data.data
        for (var i = 0; i < _arrData.length; i++) {
          this.stageTypeList.push(_arrData[i].comboValue)
        }
      })
    },
    loadComboStageNo() {
      this.stageNoList = []
      this.getActivityStageNoList({
        params: { wellId: this.wellId },
      }).then((resp) => {
        this.stageNoList = resp.data.data
      })
    },
    onRowSelected(item) {
      if (item.length === 0) {
        this.selectedRow = []
        this.$refs.tableDataCementStage.clearSelected()
        this.selectedStageNo = undefined
        return
      }
      this.selectedRow = item
      this.form = item[0]
      this.selectedStageNo = this.selectedRow[0].intId
    },
    saving(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      delete rowData.id
      rowData.submitId = this.submitId
      this.addActivityCementStage({ params: rowData }).then((resp) => {
          this.retrieveDataTable()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
      })
    },

    askServerToRemoveData() {
      if (this.selectedRow.length > 0) {
        const data = { ...this.selectedRow[0] }
        this.removeActivityCementStage({ params: data }).then((resp) => {
          this.refreshTableAndCombo()
          this.closeModalRemove()
          this.makeToast('Remove data cement stage success.')
        })
      }
    },
    ctUsedChanged(val) {
      if (val === '1') {
        this.ctUsedEnabled = false
        this.form.mdCtu = undefined
        this.form.tvdCtu = undefined
        this.form.initialCtuPress = undefined
        this.form.finalCtuPress = undefined
      } else {
        this.ctUsedEnabled = true
        this.form.mdCtu = undefined
        this.form.tvdCtu = undefined
        this.form.initialCtuPress = undefined
        this.form.finalCtuPress = undefined
      }
    },
    hesitationChanged(val) {
      if (val === '1') {
        this.hesitationEnable = false
        this.form.hesitationReason = undefined
      } else {
        this.hesitationEnable = true
        this.form.hesitationReason = undefined
      }
    },
    onSubmit(){},
    onReset(){},
    closeModalRemove() {},
  },
}
</script>